/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

interface UnauthorizedPageProps {
  reason?: 'no-role' | 'insufficient';
}

export function UnauthorizedPage({ reason = 'no-role' }: UnauthorizedPageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="w-16 h-16 bg-dds-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-dds-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {reason === 'no-role' ? 'Role Not Assigned' : 'Access Denied'}
        </h1>
        <p className="text-gray-600">
          {reason === 'no-role'
            ? 'Your account does not have an application role assigned. Contact your administrator to request access.'
            : 'You do not have sufficient permissions to access this page.'}
        </p>
      </div>
    </div>
  );
}
